// src/services/authService.js
import * as OTPLib from 'otplib';

const TOKEN_EXPIRATION_DAYS = 30; // 30 days token expiration
const TOKEN_CHECK_INTERVAL = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

// MFA Configuration
const ALLOWED_MOBILE = '+91-9910952142';
const DEFAULT_OTP = '220922';
const TOTP_SECRET_KEY = 'totp_secret';
const TOTP_SETUP_COMPLETE_KEY = 'totp_setup_complete';

// Step 1: Validate mobile number
export const validateMobileNumber = (mobile) => {
    const normalized = mobile.trim();
    if (normalized === ALLOWED_MOBILE) {
        return { success: true };
    }
    return { success: false, error: 'Mobile number not authorized' };
};

// Step 2: Validate OTP
export const validateOTP = (otp) => {
    if (otp === DEFAULT_OTP) {
        return { success: true };
    }
    return { success: false, error: 'Invalid OTP' };
};

// Step 3: TOTP Functions
export const generateTOTPSecret = () => {
    // Use the functional API which handles plugins automatically
    const secret = OTPLib.generateSecret();
    localStorage.setItem(TOTP_SECRET_KEY, secret);
    return secret;
};

export const getTOTPSecret = () => {
    let secret = localStorage.getItem(TOTP_SECRET_KEY);
    if (!secret) {
        secret = generateTOTPSecret();
    }
    return secret;
};

export const getTOTPQRCode = () => {
    const secret = getTOTPSecret();
    const user = 'ps@psudeep.com';
    const service = 'Prashant Sudeep Blog';
    // Generate otpauth:// URL for QR code
    return `otpauth://totp/${encodeURIComponent(service)}:${encodeURIComponent(user)}?secret=${secret}&issuer=${encodeURIComponent(service)}`;
};

export const validateTOTP = (token) => {
    const secret = getTOTPSecret();
    try {
        // Use the functional API which handles plugins automatically
        const isValid = OTPLib.verify({ token, secret });
        if (isValid) {
            // Mark setup as complete after first successful verification
            localStorage.setItem(TOTP_SETUP_COMPLETE_KEY, 'true');
            return { success: true };
        }
        return { success: false, error: 'Invalid authenticator code' };
    } catch (error) {
        console.error('TOTP validation error:', error);
        return { success: false, error: 'Invalid authenticator code' };
    }
};

export const isTOTPSetupComplete = () => {
    return localStorage.getItem(TOTP_SETUP_COMPLETE_KEY) === 'true';
};

export const resetTOTPSetup = () => {
    localStorage.removeItem(TOTP_SETUP_COMPLETE_KEY);
};

// Complete authentication (called after all 3 steps pass)
export const completeAuthentication = () => {
    const token = btoa(`${ALLOWED_MOBILE}:${Date.now()}:${Math.random()}`);
    setAuthToken(token);
    setUserDetails({
        mobile: ALLOWED_MOBILE,
        email: 'ps@psudeep.com',
        loginTime: new Date().toISOString()
    });
    return { success: true, token };
};

export const setAuthToken = (token) => {
    const expirationDate = new Date(new Date().getTime() + TOKEN_EXPIRATION_DAYS * 24 * 60 * 60 * 1000);
    localStorage.setItem('authToken', token);
    localStorage.setItem('token', token);
    localStorage.setItem('tokenExpiration', expirationDate.toISOString());
};

export const getAuthToken = () => {
    const token = localStorage.getItem('authToken');
    const expiration = localStorage.getItem('tokenExpiration');

    if (token && expiration && new Date(expiration) > new Date()) {
        return token;
    } else {
        removeAuthToken();
        return null;
    }
};

export const isAuthenticated = () => {
    return getAuthToken() !== null;
};

export const removeAuthToken = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('accType');
    localStorage.removeItem('email');
    localStorage.removeItem('client');
    localStorage.removeItem('userDetails');
    // Keep TOTP secret and setup status for next login
};

export const setUserDetails = (userDetails) => {
    localStorage.setItem('accType', userDetails.accType || 'admin');
    localStorage.setItem('email', userDetails.email);
    localStorage.setItem('client', userDetails.queryType || 'blog');
    localStorage.setItem('userDetails', JSON.stringify(userDetails));
};

export const getUserDetails = () => {
    const userDetails = localStorage.getItem('userDetails');
    return userDetails ? JSON.parse(userDetails) : null;
};

export const getEmail = () => {
    return localStorage.getItem('email') || null;
};

export const logout = () => {
    removeAuthToken();
    window.location.href = '/auth/login';
};

// Legacy functions for backward compatibility
export const checkTokenValidity = async () => {
    return isAuthenticated();
};

export const startTokenValidityCheck = () => {
    setInterval(async () => {
        if (!isAuthenticated()) {
            // Optionally, redirect to login page or show a notification
            if (window.location.pathname !== '/auth/login') {
                window.location.href = '/auth/login';
            }
        }
    }, TOKEN_CHECK_INTERVAL);
};

// Call this function when your app initializes
export const initializeAuth = () => {
    startTokenValidityCheck();
};
